import React, { useState, useMemo } from "react";

export default function OverviewExpand({ html, limit = 2500 }) {
  const [expanded, setExpanded] = useState(false);
  const [showToggle, setShowToggle] = useState(false)

  const truncatedHtml = useMemo(() => {
    if (!html) return "";

    const temp = document.createElement("div");
    temp.innerHTML = html;
    const text = temp.textContent || "";

    setShowToggle(text.length <= limit?false:true)
    if (text.length <= limit) return html;
    temp.innerHTML=html.slice(0, limit)
    const temp2=temp.textContent || "";

    // Hard truncate (safe for paragraphs)
    return html.slice(0, limit+(limit-temp2.length)) + "...";
  }, [html, limit]);


  return (
    <div className="content ">
      <div
        dangerouslySetInnerHTML={{
          __html: expanded ? html : truncatedHtml
        }}
      />

      {showToggle && (
        <p
          onClick={() => setExpanded(!expanded)}
          style={{
            marginTop: 10,
            background: "none",
            border: "none",
            color: "#007bff",
            cursor: "pointer",
            fontWeight: 600
          }}
        >
          {expanded ? "View Less" : "View More"}
        </p>
      )}
    </div>
  );
}
